/* This is the EMIS class Enviroment for secondary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table width="800px;" border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td class="row-title-long" colspan="6">
              ចំនួនបន្ទប់ប្រើប្រាស់សម្រាប់បង្រៀន
            </td>
          </tr>
          <tr>
            <td class="row-data">ភូមិសិក្សា</td>
            <td class="row-data">ចំនួនបន្ទប់រៀនសរុប</td>
            <td class="row-data">មានអគ្គីសនី</td>
            <td class="row-data">មានអំពូល</td>
            <td class="row-data">មានកង្ហារ/ម៉ាស៊ីនត្រជាក់</td>
            <td class="row-data">បំពាក់ឧបករណ៍ទំនើប</td>
          </tr>
          <!--Pre school level-->
          <tr v-if="preOnOff === 1">
            <td class="row-title">សម្រាប់មត្តេយ្យសិក្សា</td>
            <td class="row-data">
              <numberinput v-model="data_pre[0].clr_pre" class="number" />
            </td>
            <td v-for="(value, col) in data_pre.length" :key="col" class="row-data">
              <numberinput v-model="data_pre[col].dt[0]" class="number" />
            </td>
          </tr>
          <!--Primary school level-->
          <tr>
            <td class="row-title">សម្រាប់បឋមសិក្សា</td>
            <td class="row-data">
              <numberinput v-model="data_pri[0].clr_pri" class="number" />
            </td>
            <td v-for="(value, col) in data_pri.length" :key="col" class="row-data">
              <numberinput v-model="data_pri[col].dt[0]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data_pre", "data_pri", "title", "preOnOff"],
  components: {
    numberinput: NumberInput,
  },
};
</script>

<style scoped>
.number {
  width: 120px;
  text-align: center;
}
.row-data {
  width: 120px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-title {
  width: 150px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-title-long {
  width: 600px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>